export enum ItemReplacementTypeCode {
  DamagedDuringAlt = 'DAM-ALT',
  DamagedByManuf = 'DAM-MAN',
  DamagedInShipping = 'DAM-SHIP',
  Lost = 'LOST',
  WrongItem = 'WRONG',
  WrongByManuf = 'WRONG-MAN'
}
